export function getItemLayoutSx(style) {
    var _a, _b;
    const align = (_a = style === null || style === void 0 ? void 0 : style.align) !== null && _a !== void 0 ? _a : 'left';
    const layout = (_b = style === null || style === void 0 ? void 0 : style.layout) !== null && _b !== void 0 ? _b : ((style === null || style === void 0 ? void 0 : style.inline) ? 'inline' : 'column');
    switch (layout) {
        case 'column':
            switch (align) {
                case 'left':
                    return { alignSelf: 'flex-start', gap: 1 };
                case 'center':
                    return { alignSelf: 'center', gap: 1 };
                case 'right':
                    return { alignSelf: 'flex-end', gap: 1 };
            }
            break;
        case 'inline':
            switch (align) {
                case 'left':
                    return { flexDirection: 'row', gap: 1, justifyContent: 'flex-start' };
                case 'center':
                    return { flexDirection: 'row', gap: 1, justifyContent: 'center' };
                case 'right':
                    return { flexDirection: 'row', gap: 1, justifyContent: 'flex-end' };
            }
            break;
        case '2-columns-fit':
            switch (align) {
                case 'left':
                    return {
                        alignSelf: 'flex-start',
                        display: 'grid',
                        gridTemplateColumns: {
                            xs: `100%`,
                            sm: `auto auto`,
                        },
                        gap: 1,
                        justifyItems: 'stretch',
                    };
                case 'center':
                    return {
                        alignSelf: 'center',
                        display: 'grid',
                        gridTemplateColumns: {
                            xs: `100%`,
                            sm: `auto auto`,
                        },
                        gap: 1,
                        justifyItems: 'stretch',
                    };
                case 'right':
                    return {
                        alignSelf: 'flex-end',
                        display: 'grid',
                        gridTemplateColumns: {
                            xs: `100%`,
                            sm: `auto auto`,
                        },
                        gap: 1,
                        justifyItems: 'stretch',
                    };
            }
            break;
        case '2-columns-stretch':
            switch (align) {
                case 'left':
                    return {
                        display: 'grid',
                        gridTemplateColumns: (theme) => ({
                            xs: `100%`,
                            sm: `calc(50% - ${theme.spacing(0.5)}) calc(50% - ${theme.spacing(0.5)})`,
                        }),
                        gap: 1,
                        justifyItems: 'flex-start',
                    };
                case 'center':
                    return {
                        display: 'grid',
                        gridTemplateColumns: (theme) => ({
                            xs: `100%`,
                            sm: `calc(50% - ${theme.spacing(0.5)}) calc(50% - ${theme.spacing(0.5)})`,
                        }),
                        gap: 1,
                        justifyItems: 'center',
                    };
                case 'right':
                    return {
                        display: 'grid',
                        gridTemplateColumns: (theme) => ({
                            xs: `100%`,
                            sm: `calc(50% - ${theme.spacing(0.5)}) calc(50% - ${theme.spacing(0.5)})`,
                        }),
                        gap: 1,
                        justifyItems: 'flex-end',
                    };
            }
    }
}
